import { Apple, Play } from 'lucide-react';
import type { OneLinkWidgetData } from '@/types';

interface OneLinkWidgetProps {
  data: OneLinkWidgetData;
}

const OneLinkWidget = ({ data }: OneLinkWidgetProps) => {
  const hasAppStore = !!data.appStoreUrl;
  const hasPlayStore = !!data.playStoreUrl;

  return (
    <div className="bg-white dark:bg-dark-800 rounded-2xl p-4 shadow-soft dark:shadow-none">
      <div className="flex items-center gap-4 mb-4">
        {data.iconUrl ? (
          <img
            src={data.iconUrl}
            alt={data.appName}
            className="w-16 h-16 rounded-2xl object-cover"
          />
        ) : (
          <div className="w-16 h-16 rounded-2xl bg-gradient-to-br from-lime-400 to-lavender-400 flex items-center justify-center">
            <span className="text-2xl font-bold text-white">
              {data.appName.charAt(0).toUpperCase()}
            </span>
          </div>
        )}

        <div className="flex-1 min-w-0">
          <h3 className="font-semibold text-dark-800 dark:text-white truncate">{data.appName}</h3>
          <p className="text-sm text-gray-500 dark:text-gray-400">Disponible sur</p>
        </div>
      </div>

      <div className="flex gap-3">
        {hasAppStore && (
          <a
            href={data.appStoreUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="flex-1 flex items-center justify-center gap-2 bg-dark-800 text-white py-3 px-4 rounded-xl hover:bg-dark-700 transition-colors"
          >
            <Apple className="w-5 h-5" />
            <div className="text-left">
              <div className="text-[10px] leading-none opacity-80">Télécharger sur</div>
              <div className="text-sm font-semibold">App Store</div>
            </div>
          </a>
        )}

        {hasPlayStore && (
          <a
            href={data.playStoreUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="flex-1 flex items-center justify-center gap-2 bg-dark-800 text-white py-3 px-4 rounded-xl hover:bg-dark-700 transition-colors"
          >
            <Play className="w-5 h-5 fill-current" />
            <div className="text-left">
              <div className="text-[10px] leading-none opacity-80">Disponible sur</div>
              <div className="text-sm font-semibold">Google Play</div>
            </div>
          </a>
        )}
      </div>
    </div>
  );
};

export default OneLinkWidget;
